import { render, staticRenderFns } from "./TdLogo.vue?vue&type=template&id=59b70662&scoped=true&"
import script from "./TdLogo.vue?vue&type=script&lang=ts&"
export * from "./TdLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b70662",
  null
  
)

export default component.exports